export const SHOP_LINKS = [
  { label: "Shop All", to: "/shop/" },
  { label: "Flower", to: "/shop/flower/" },
  { label: "Pre-Rolls", to: "/shop/pre-rolls/" },
  { label: "Edibles", to: "/shop/edibles/" },
  { label: "Vapes", to: "/shop/vapes/" },
  { label: "Cartridges", to: "/shop/cartridges/" },
  { label: "Concentrates", to: "/shop/concentrates/" },
  { label: "Deals", to: "/deals/" },
];

export const DELIVERY_LINKS = [
  { label: "Delivery Details", to: "/delivery/" },
  { label: "DC Cannabis Delivery", to: "/dc-cannabis-delivery/" },
  { label: "DC Weed Delivery", to: "/dc-weed-delivery/" },
  { label: "Service Areas", to: "/locations/" },
  { label: "Pickup", to: "/pickup/" },
];

export const NAV = [
  { label: "Shop", to: "/shop/", children: SHOP_LINKS },
  { label: "Deals", to: "/deals/" },
  { label: "Delivery", to: "/delivery/", children: DELIVERY_LINKS },
  { label: "How to Order", to: "/how-to-order/" },
  { label: "About", to: "/about/" },
  { label: "FAQ", to: "/faq/" },
  { label: "Contact", to: "/contact/" },
];

export const COMPANY_LINKS = [
  { label: "About SHADC", to: "/about/" },
  { label: "Washington DC Dispensary", to: "/washington-dc-dispensary/" },
  { label: "How to Order", to: "/how-to-order/" },
  { label: "FAQ", to: "/faq/" },
  { label: "Blog & Guides", to: "/blog/" },
  { label: "Contact", to: "/contact/" },
];

export const LEGAL_LINKS = [
  { label: "Terms of Use", to: "/terms/" },
  { label: "Privacy Policy", to: "/privacy-policy/" },
  { label: "Delivery Policy", to: "/delivery-policy/" },
  { label: "Refund & Cancellation", to: "/refund-policy/" },
  { label: "Responsible Use", to: "/responsible-use/" },
];
